import _UserDashboard from './component';
import _routes from './routes';

export const UserDashboard = _UserDashboard;
export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/UserDashboard/index.js